import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Input, Button, Checkbox } from 'antd';

import wasabiDarkLogo from '../../../assets/logo/wasabi_header_logo_dark.png';
import './verifyEmail.scss'

class VerifyEmail extends React.Component {
    render(){
        return(
            <div className="verifyEmail-wrapper">
                <div className="verifyEmail-form">
                    <div className="wasabiLogo">
                        <img alt="wasabi Logo" src={wasabiDarkLogo} />
                    </div>
                    <div className="text-wrapper">
                        <div className="verifyEmail-form-text">
                            <h3>Welcome to Wasabi Bucket Replication Manager</h3>
                            <p>We have received your request for a Wasabi Bucket Replication Manager account. To complete your account set up, please click the button below to verify your email address. The link will expire after 24 hours.</p>
                        </div>
                        <div className="verifyEmail-button">
                            <Button
                                className="btn-login"
                                type="primary"
                                size="large"
                                // loading={this.state.loading}
                                htmlType="submit"
                                block>
                                Verify Your Email Addess
                            </Button>
                        </div>
                        <div className="verifyEmail-note">
                            <p>For additional assistance, please contact us <span>here</span>.</p>
                            <p>For all other non-technical inquiries please feel free to connect with us <span>here</span>.</p>
                        </div>
                    </div>
                    
                    <div className="verifyEmail-footer"></div>
                </div>
                
            </div>
        )
    }

}
export default withRouter(
    connect(
        // mapStateToProps,
        // mapDispatchToProps
    )(Form.create()(VerifyEmail))
)